import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import InputLabel from '@material-ui/core/InputLabel';
import AcceptedDocumentTypeManager from '../../managers/AcceptedDocumentTypeManager';
import './AttachementField.scss';

const acceptedDocumentTypeManager = new AcceptedDocumentTypeManager();

class AttachementField extends Component {
  constructor(props) {
    super(props);
    this.acceptedDocumentTypeManager =
      props.acceptedDocumentTypeManager || acceptedDocumentTypeManager;
  }

  handleDrop = files => {
    if (!files || !files[0] || !this.props.onDrop) {
      return;
    }

    this.props.onDrop(files);
  };

  render() {
    const dropzoneStyle = {
      width: '100%',
      height: '70px',
      border: 'dashed 0.7px #becad6',
      cursor: 'pointer'
    };

    const dropzoneDisabledStyle = {
      width: '100%',
      height: '100%',
      border: 'dashed 0.7px #becad6',
      borderRadius: 5,
      background: 'rgba(255, 255, 255, .5)',
      paddingLeft: '10px'
    };

    return (
      <div className="attachment-form__upload-content">
        <InputLabel>{this.props.attachmentLabel}</InputLabel>
        <Dropzone
          accept={this.acceptedDocumentTypeManager.dropzoneAccept()}
          multiple={false}
          onDrop={this.handleDrop}
          disabled={this.props.disabledDocuments}
          style={dropzoneStyle}
          disabledStyle={dropzoneDisabledStyle}
        >
          {({ getRootProps, getInputProps }) => (
            <section>
              <div {...getRootProps()}>
                <input {...getInputProps()} />
                <div className="attachment-form__upload-files">
                  <div className="drop-instruction">
                    <h3 className="upload-indication">
                      {this.acceptedDocumentTypeManager.hintText()}
                    </h3>
                    <div className="drop-icons-box">
                      <img
                        src="/images/icons/upload-icon.svg"
                        className="upload-icon"
                        alt="upload-icon"
                      />
                    </div>
                  </div>
                  {this.props.document &&
                    Object.keys(this.props.document).length > 0 &&
                    (this.props.document.url || this.props.document.size) && (
                      <div className="attachment-form__existing-files">
                        <ul className="attachment-form__file-list">
                          <li
                            key={
                              this.props.document.name ||
                              this.props.document.file_file_name
                            }
                          >
                            {this.props.document.name ||
                              this.props.documentFilename}
                          </li>
                        </ul>
                        <div className="attachment-form__remove-files">
                          <button
                            type="button"
                            className="general-button"
                            onClick={() => this.props.removeDocument()}
                          >
                            <h4 className="attachement-form__delete">
                              Șterge Fisier
                            </h4>
                          </button>
                        </div>
                      </div>
                    )}
                </div>
              </div>
            </section>
          )}
        </Dropzone>
      </div>
    );
  }
}

export default AttachementField;
